export default __webpack_public_path__ + "static/media/MISTRZ_ODWAGI.f84dbf95.png";